import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Dropdown from '../../../dashboard/common/dropdown/Dropdown';

const ExtendBookingPopup = props => {
  const [extendedBookingHour, setExtendedBookingHour] = useState([]);
  const { booking, formatString, officeDetails, trans, fetchBookingDetails } = props;
  const id = _.get(booking, 'id', null);
  const closingOfficeTime = moment.utc().set({
    hour: _.get(officeDetails, 'openingHours.0.toHour', ''),
    minute: _.get(officeDetails, 'openingHours.0.toMinute', ''),
  });
  const location = _.get(booking, 'office.name', null);
  const officeType = _.get(booking, 'product.officeTypeId', 0) === 1 ? 'desk' : 'meeting room';
  const startHours = `${_.get(booking, 'hours.from.hour')}:${_.get(booking, 'hours.from.minute')}`;
  const endHours = `${_.get(booking, 'hours.to.hour')}:${_.get(booking, 'hours.to.minute')}`;
  const bookingTimeEnd = moment.utc().set({
    hour: _.get(booking, 'hours.to.hour'),
    minute: _.get(booking, 'hours.to.minute'),
  });
  const tempTime = _.clone(bookingTimeEnd).add(30, 'minutes');
  const extendOptions = [];
  while (tempTime <= closingOfficeTime) {
    const tempFormatted = tempTime.format('H:mm');
    extendOptions.push({ id: tempFormatted, value: tempFormatted });
    tempTime.add(30, 'minutes');
  }
  return (
    <div className="cancelBooking">
      <div onClick={props.onCancelAction} className="modal-close-button" />
      <div className="bookedOffice-popup-title">{_.get(trans, 'whiteLabel.extendTitle', 'whiteLabel.extendTitle')}</div>
      <div className="bookedOffice-popup-body">
        <span className="bookedOffice-text">
          {formatString(_.get(trans, 'whiteLabel.extendCustomMessage', ''), officeType, startHours, location, endHours)}
        </span>
        <Dropdown
          onChange={selectedHour => setExtendedBookingHour(selectedHour)}
          options={extendOptions}
          selectedId="all"
          className="dropdown__selector filter__dropdown extend-hour__dropdown"
          customText={_.get(trans, 'whiteLabel.extendUntil', 'Extend until: ')}
        />
      </div>
      <div className="cancelBooking-actions">
        <button style={{ marginLeft: '0' }} className="cancelBooking-blockButton secondary-button" onClick={props.onCancelAction}>
          {_.get(trans, 'modals.mobileApp.cancel', 'Cancel')}
        </button>
        <button
          style={{ marginLeft: '0' }}
          className="cancelBooking-cancelButton bookedOffice-submitButton main-button"
          onClick={() => {
            props
              .onAction(id, extendedBookingHour)
              .then(response => {
                props.setToastMessage(response.message);
                fetchBookingDetails(id);
              })
              .catch((response = {}) => {
                props.setToastMessage(response);
              });
            props.onCancelAction();
          }}
        >
          {_.get(trans, 'whiteLabel.add', '')}
        </button>
      </div>
    </div>
  );
};
export default ExtendBookingPopup;
